import { createSlice } from '@reduxjs/toolkit';
import { REDUX_STORE_SLICES } from '../../services/exports/Constants';
import { SliceCaseReducers } from '@reduxjs/toolkit/dist/createSlice';
import { OfferInitialState, StoreInterface } from '../types';

const initialState: OfferInitialState = {
  activeOffers: [],
  appliedOffers: [],
  eligibleOffers: [],
  unlockedOffers: [],
} as const;

const offerSlice = createSlice<OfferInitialState, SliceCaseReducers<OfferInitialState>>({
  name: REDUX_STORE_SLICES.OFFER,
  initialState,
  reducers: {
    setOffers: (draft, action): void => {
      Object.assign(draft, action.payload);
    },
  },
});

export default offerSlice;

export const { setOffers } = offerSlice.actions;
export const selectActiveOffers = (state: StoreInterface) => state[REDUX_STORE_SLICES.OFFER].activeOffers;
export const selectEligibleOffers = (state: StoreInterface) => state[REDUX_STORE_SLICES.OFFER].eligibleOffers;
export const selectUnlockedOffers = (state: StoreInterface) => state[REDUX_STORE_SLICES.OFFER].unlockedOffers;
export const selectAppliedOffers = (state: StoreInterface) => state[REDUX_STORE_SLICES.OFFER].appliedOffers;
export const selectOffersSlice = (state: StoreInterface) => state[REDUX_STORE_SLICES.OFFER];
